import React from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { PageLayout, Section, Text, Bullets } from "./PageLayout";

const steps = [
  {
    title: "Unverbindliches Erstgespräch und Angebot",
    text: "Wir lernen Ihre Gemeinschaft und Ihr Objekt kennen, klären offene Fragen und erstellen ein individuelles Angebot. Kostenlos und ohne Verpflichtung.",
  },
  {
    title: "Beschluss der Eigentümerversammlung",
    text: "Die Eigentümer beschließen den Verwalterwechsel in der Versammlung. Auf Wunsch stellen wir uns vorab persönlich vor und liefern eine Beschlussvorlage.",
  },
  {
    title: "Übernahme der Unterlagen vom bisherigen Verwalter",
    text: "Die Abstimmung mit der bisherigen Verwaltung, die Übergabe von Unterlagen, Konten und Verträgen übernehmen wir. Sie müssen sich um nichts kümmern.",
  },
  {
    title: "Start mit festem Ansprechpartner",
    text: "Ab dem vereinbarten Termin sind wir für Sie da: mit einer Ansprechperson, die Ihr Objekt kennt, und klaren Abläufen von Anfang an.",
  },
];

export default function Verwalterwechsel() {
  return (
    <PageLayout
      path="/verwalterwechsel"
      eyebrow="Verwalterwechsel"
      title="Verwalterwechsel – so einfach geht's"
      intro="Unzufrieden mit Ihrer Verwaltung? Ein Wechsel ist weniger aufwendig, als viele Eigentümer denken. Wir begleiten Sie durch alle Schritte und übernehmen die Abstimmung mit dem bisherigen Verwalter."
      testId="verwalterwechsel-page"
    >
      <ol className="space-y-5" data-testid="wechsel-steps">
        {steps.map((s, i) => (
          <li key={s.title} className="flex gap-5 rounded-3xl border border-brand-100 bg-white p-6">
            <div className="w-12 h-12 rounded-2xl bg-accent2 text-brand-900 font-display font-extrabold text-xl flex items-center justify-center shrink-0">
              {i + 1}
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-brand-900">{s.title}</h2>
              <p className="mt-2 text-brand-700 leading-relaxed text-[15px]">{s.text}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-10 rounded-2xl border border-accent2/40 bg-accent2/10 p-6 flex gap-4" data-testid="wechsel-hinweis">
        <Info className="w-6 h-6 text-accent2 shrink-0" />
        <div>
          <div className="font-semibold text-brand-900">Auch kurzfristig möglich</div>
          <p className="mt-1 text-[15px] text-brand-700 leading-relaxed">
            Seit der WEG-Reform (§ 26 Abs. 3 WEG) kann die Eigentümergemeinschaft den Verwalter
            jederzeit abberufen, ohne dass ein wichtiger Grund vorliegen muss. Der Verwaltervertrag
            endet spätestens sechs Monate nach der Abberufung. Ein Wechsel ist deshalb auch
            kurzfristig umsetzbar.
          </p>
        </div>
      </div>

      <Section title="Was Sie für den Wechsel brauchen">
        <Bullets items={["Aktuellen Verwaltervertrag und Kündigungsfristen", "Letzte Jahresabrechnung und Wirtschaftsplan", "Teilungserklärung und Gemeinschaftsordnung", "Anzahl der Einheiten und Besonderheiten der Anlage"]} />
        <Text>
          Fehlen Unterlagen, ist das kein Hindernis. Wir fordern sie im Rahmen der Übergabe beim
          bisherigen Verwalter an. Mehr zu unseren Leistungen finden Sie unter{" "}
          <Link to="/weg-verwaltung-kleve" className="underline text-brand-900" data-testid="link-weg-verwaltung">
            WEG-Verwaltung in Kleve und am Niederrhein
          </Link>
          .
        </Text>
      </Section>
    </PageLayout>
  );
}
